/* eslint-disable react-hooks/exhaustive-deps */
import { type RefObject, useEffect, useRef } from "react"

import eq from "lodash-es/eq"
import { useBoolean, useTimeoutFn } from "react-use"

import type { TEmptyCallback } from "@/shared/types/functions"

function useQueryDelayedEnabled(isEnabled: boolean, delayTime: number): boolean {
    const initial: RefObject<boolean> = useRef<boolean>(isEnabled)

    const [isQueryEnabled, setIsQueryEnabled]: ReturnType<typeof useBoolean> = useBoolean(false)

    const [startTimeout, cancelTimeout, resetTimeout]: [TEmptyCallback, TEmptyCallback, TEmptyCallback] = useTimeoutFn(
        (): void => setIsQueryEnabled(isEnabled),
        delayTime
    )

    useEffect((): TEmptyCallback => {
        startTimeout()

        if (!eq(isEnabled, initial.current)) resetTimeout()

        return cancelTimeout
    }, [isEnabled, delayTime])

    return isQueryEnabled
}

export default { useQueryDelayedEnabled }
